import { Checkbox } from 'antd';
import HmsFormItem from 'components/Form/HmsFormItem';

const CheckboxGroup = Checkbox.Group;


const FormRoleSelector = ({ label, name, required, formItemProps, fieldItemProps, options, dataType = 'CSV' }) => {


    const CheckboxGroupItem = ({ checked, onChange, ...props }) => {
        return (
            <div>
                <CheckboxGroup
                    {...props}
                    value={dataType === 'CSV' ? (checked ?? '').split(',').filter(r => r.trim()) : (checked ?? [])}
                    onChange={(checked) => { 
                        onChange(dataType === 'CSV' ? checked.join(',') : checked);
                    }}
                    className="w-full"
                >
                    <div className="flex flex-col border-[1px] border-[#d9d9d9] rounded-md p-2 px-3 w-full">
                        {options.map((option) => (
                            <Checkbox key={option.value} value={option.value} disabled={option.disabled} className="select-none">
                                {option.label}
                            </Checkbox>
                        ))}
                    </div>
                </CheckboxGroup>
            </div>
        );
    };

    return (
        <HmsFormItem
            label={label}
            name={name}
            required={required}
            valuePropName='checked'
            {...formItemProps}
            rules={[
                ...(formItemProps?.rules || [])
            ]}
        >
            <CheckboxGroupItem
                options={options}
                {...fieldItemProps}
            />
        </HmsFormItem>
    );
};

export default FormRoleSelector;
